import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { getCampsPaged, getTotal, removethisItem, exportSchool } from '../../API/FetchCall';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../src/assets/bewiseloading.gif';

class verticalCamps extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location:  localStorage.getItem("location")? localStorage.getItem("location"):'Bengaluru',
              campList: [],
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
              exportbtndisabled:false,  
              thisExportBtnText:'Export'
        };

        this.handleSelect = this.handleSelect.bind(this);
        //this.getList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        
         let ins = JSON.stringify({
            id: delete_id,
            table:'camp'
          });

          removethisItem(ins).then((res) => {

              alert(res.message);
              THIS.getTotal('bw_sesonal_camp');
              THIS.getList();

          });

      });


      this.getTotal('bw_sesonal_camp');
      this.getList();      

    }

    getTotal = (vertical, location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotal(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  


    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        offset:newOffset
      });

      getCampsPaged(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            campList: res.data
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            campList: [],
          });
        }
      });


    }    


 handlePageChange(pageNumber) {

      console.log(`active page is ${pageNumber}`);

      this.setState({activePage: pageNumber});

      //this.getTotal('bw_schools');
      this.getList(pageNumber);


  }
 
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  searchBy = (e) => {
      
      this.setState({loading:true, activePage:1});

      this.getTotal('bw_schools');
      this.getList(1); 

  };


  handleSelect = (e) => {
      
      this.setState({ location: e.target.value, activePage:1});
      localStorage.setItem("location",e.target.value);
      this.getTotal('bw_schools', e.target.value);
      this.getList(1, e.target.value);

  };


  schoolExport = async () => {

    this.setState({exportbtndisabled:true, thisExportBtnText:"exporting..."});

    try {
      let req = JSON.stringify({
        location: this.state.location
      })
      const res = await exportSchool(req);
      if (res.status == 1) {

        this.setState({exportbtndisabled:false, thisExportBtnText:"Export"});
        console.log('location_list', res)
        console.log('location_list', res.path)
        window.open(res.path)

        // this.setState({
        //   subscribe_list: res.results,
        // });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  }  


    render() {

        const { campList, currentPage, PER_PAGE, totalCount, total, exportbtndisabled } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
                        <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Learning Camps</h4>
                 
                  <div class="float-right"><a href="/vertical/learningcamps/add" class="btn btn-primary btn-sm">Add</a> &nbsp;<button disabled={exportbtndisabled} class="btn btn-primary btn-sm"  onClick={() => this.schoolExport()}>{this.state.thisExportBtnText}</button> </div>
                  <p class="card-description">
                    <div class="cityselection">
                      <div class="leftaligned bwlabel">City</div>
                      <div class="leftaligned"><select name="location" class="form-control" onChange={(e) => this.handleSelect(e)}
                                                       value={this.state.location}>
                                                      <option value="">select city</option>
                                                      <option value="Bengaluru">Bengaluru</option>
                                                      <option value="Chennai">Chennai</option>
                                                      <option value="Hyderabad">Hyderabad</option>
                                                      <option value="Coimbatore">Coimbatore</option>
                                                      <option value="Hosur">Hosur</option>
                                                      <option value="Indore">Indore</option>
                                                      <option value="Others">Others</option>
                                              </select>
                      </div>

                      <div class="leftaligned bwlabel">Search</div>
                      <div class="leftaligned"><input type="text" name="searchby" class="form-control form-control-sm" onChange={this.handleChange} /></div>
                      <div class="leftaligned"><button class="btn btn-primary btn-sm" onClick={this.searchBy}>Go</button></div>
                    </div>
                  </p>

                  {this.state.loading &&
                    <div id="loader">
                      <img src={BeWiseLoading} width="60px"/>
                    </div>  
                  }

                    <div class="pt-3">

                    {!this.state.loading &&
         
                    <table id="tablebw">
                      <thead class="thead-dark">
                       <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Updated On</strong>
                          </th>
                          <th>
                            <strong>By</strong>
                          </th>
                          <th>
                            <strong>Name</strong>
                          </th>

                          <th>
                            <strong>City</strong>
                          </th>

                          <th>
                            <strong>Email Id</strong>
                          </th>

                          <th>
                            <strong>Status</strong>
                          </th>

                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        
                      {campList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                           {item.s_no}
                          </td>
                          <td>
                           {item.updated_date}
                          </td>
                          
                          <td>
                           {item.updatedby}
                          </td>
                          <td>
                            {item.organisation_name}
                          </td>
                          <td>
                            {item.location}
                          </td>
                          <td>
                            {item.email_id}
                          </td>
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                     
                          <td class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />
                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>

                     }


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>


                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalCamps;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalCamps.jsx